<template>
<body>
    <div id="kits">

        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>-->
           <!-- <v-layout row wrap>
            <v-flex sm4 md4 lg3 class="pl-4 ml-4 pt-5" >
            <v-card style="background-color:#B43980">
              <v-card-title ><span class="titledibujos" style="color:white; font-family:Poppins;  font-weight:600">DIBUJOS</span></v-card-title>
            </v-card>
            </v-flex>
            <v-flex md1 class="pt-5" >
            <v-card flat style="background-color:#D6D6D6">
              <img src="dibujos.png"  style="position:absolute;margin-left:-30px; margin-top:-2px" />
            </v-card>
            </v-flex>
            </v-layout>-->
            <ContentKits :kits="kits">
            </ContentKits>
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentKits from "@/components/ContentKits.vue"

export default {
   
    components:{
       ContentKits
     },

    data(){
        return{
            title:"DIBUJOS",
            kits:[
          
          
          {title:"Kit Lalabum 1k",img:"kit_1k.png", url:"../descargas/files/kits/kit_1k.pdf",namedownload:"kit_lalabum_1k"},
          {title:"Kit Lalabum 2k",img:"kit_2k.png",url:"../descargas/files/kits/kit_2k.pdf",namedownload:"kit_lalabum_2k"},
          {title:"Kit Lalabum 3k",img:"kit_3k.png",url:"../descargas/files/kits/kit_3k.pdf",namedownload:"Kit_lalabum_3k"},         
         
          
        ]
        }
    }
}
</script>

<style>

body{
  background-color: #D6D6D6;
  height: 100%;
}

@media (min-width: 750px){
  .titledibujos{
    font-size:1.2vw;
  }
}

@media (min-width: 300px) and (max-width: 750px){
   .titledibujos{
    font-size:4.2vw;
  }
}
</style>


